import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';
import 'array.prototype.fill';
import 'array.prototype.filter';
import 'jspolyfill-array.prototype.find'
import './js/helper/Configuration';
import "./js/index.css"
import React from 'react';
import ReactDOM from 'react-dom';
import App from './js/App';
import registerServiceWorker from './js/registerServiceWorker';
import moment from 'moment'
import 'moment/locale/de';

moment.locale('de');

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
